exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "table tbody tr td:nth-of-type(5){padding:0!important;text-align:start!important}table tbody tr td:nth-of-type(6){display:inline-flex}table tbody tr td:nth-of-type(6) button:last-of-type{cursor:default}table tbody tr .approvalTimes{color:#b90a00;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/unit/unit-list.scss
// module id = 637
// module chunks = 0